import Layout from "layout/Layout"
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import SearchInput from "@/components/Help/SearchInput";
import MainCategories from "@/components/Help/MainCategories";
import { listCategoriesHelp } from "services/allServices";
import Head from "next/head";

const index = ({ categories, locale }) => {
    const { t } = useTranslation(["common", "nav", "help"]);

    return (
        <Layout>
            <Head>
                <title>{t("common:helpMetaTitle")}</title>
                <meta name="description" content={t("common:helpMetaDescription")} />
                <meta property="og:title" content={t("common:helpMetaTitle")} key="title" />
                <meta property="og:description" content={t("common:helpMetaDescription")} key="description" />
                <meta property="og:image" content="https://makdos.com/headerLogo.png" />
            </Head>
            <div className="py-10 bg-makdosSecondaryGray">
                <div className="container p-5 mx-auto bg-white rounded-md">
                    <h1 className="text-3xl font-semibold text-black">{t("help:welcomeHelp")}</h1>

                    <p className="pt-3 text-lg text-textGray">{t("help:welcomeHelpDescription")}</p>

                    <SearchInput />

                    <div className="pt-8">
                        <MainCategories categories={categories} locale={locale} />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default index

export const getServerSideProps = async ({ locale }) => {
    const languageId = locale === "tr" ? 1 : 2;
    let categories = {};
    await listCategoriesHelp(languageId).then((res) => {
        if (res.status !== "category_not_found") {
            categories = res;

        } else {
            categories = [];
        }
    })

    return {
        props: {
            ...await serverSideTranslations(locale, ["common", "nav", "help"]),
            categories: categories,
            locale: locale
        }
    };
};